import { supabase } from '../../shared/lib/supabase';

export interface ExternalExtractionResult {
  success: boolean;
  characterCount?: number;
  qualityScore?: number;
  method?: string;
  error?: string;
}

export async function extractWithPdfCo(
  documentId: string,
  userId: string
): Promise<ExternalExtractionResult> {
  try {
    const apiUrl = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/extract-with-pdfco`;

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        documentId,
        userId,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Extraction service failed: ${response.status} - ${errorText}`);
    }

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.error || 'Unknown extraction error');
    }

    return {
      success: true,
      characterCount: result.characterCount,
      qualityScore: result.qualityScore,
      method: result.method,
    };

  } catch (error: any) {
    console.error('External extraction error:', error);
    return {
      success: false,
      error: error.message,
    };
  }
}
